import { DateTime } from 'luxon';
import { IlogisticServiceDetails } from '../../../../../../types/services';
import { additionalDaysForUnassignmentCollectionDate } from '../../../../../../utils/productDefinitions';
import { formatShortDate } from '../../../../../../utils/formatDatesAndHours';

import InfoDisplayItem from './InfoDisplayItem';
import BordOneToneIcon from '../../../../../../components/NudosComponents/BordOneToneIcon/BordOneToneIcon';
import './LogisticServiceDatesAndProgrammingDetails.scss';

const InitialEstimatedDates = ({ logisticServiceData }: { logisticServiceData: IlogisticServiceDetails }) => {
  const { collectionInfo, deliveryInfo, estimatedDeliveryTime } = logisticServiceData;
  const getInitialEstimatedDatesData = () => {
    const estimatedDeliveryText = `${estimatedDeliveryTime?.since || ''} ${
      estimatedDeliveryTime?.until ? `- ${estimatedDeliveryTime?.until}` : ''
    } días hábiles`;
    const estimatedUpperLimitForChosenCollectionDate = DateTime.fromISO(collectionInfo?.chosenCollectionDate || '')
      .plus({ days: additionalDaysForUnassignmentCollectionDate })
      .toISODate();
    const estimatedUpperLimitForChosenDeliveryDate = DateTime.fromISO(deliveryInfo?.chosenDeliveryDate || '')
      .plus({ days: additionalDaysForUnassignmentCollectionDate })
      .toISODate();
    const formatedLowerLimitCollection = formatShortDate(collectionInfo?.chosenCollectionDate || '')?.onlyDate || '';
    const formatedUpperLimitCollection = `- ${
      formatShortDate(estimatedUpperLimitForChosenCollectionDate || '')?.onlyDate || ''
    }`;
    const formatedLowerLimitDelivery = formatShortDate(deliveryInfo?.chosenDeliveryDate || '')?.onlyDate || '';
    const formatedUpperLimitDelivery = `- ${
      formatShortDate(estimatedUpperLimitForChosenDeliveryDate || '')?.onlyDate || ''
    }`;

    if (collectionInfo?.chosenCollectionDate) {
      return {
        collectionDatesText: `${formatedLowerLimitCollection} ${formatedUpperLimitCollection}`,
        estimatedDeliveryText
      };
    }
    if (deliveryInfo?.chosenDeliveryDate) {
      const choseDeliveryDateText = `${formatedLowerLimitDelivery} ${formatedUpperLimitDelivery}`;
      return { collectionDatesText: undefined, estimatedDeliveryText: choseDeliveryDateText };
    }
    return { collectionDatesText: undefined, estimatedDeliveryText };
  };

  const initialEstimatedDatesData = getInitialEstimatedDatesData();
  const transformMinCollectionDate = formatShortDate(collectionInfo?.user?.minCollectionDate || '')?.onlyDate || '';
  const transforMaxDeliveryDate = formatShortDate(deliveryInfo?.user?.maxDeliveryDate || '')?.onlyDate || '';
  const validateEstimatedDeliveryDate =
    initialEstimatedDatesData?.estimatedDeliveryText || estimatedDeliveryTime || deliveryInfo?.user?.maxDeliveryDate;
  const renderCollectionDateText = deliveryInfo?.user?.maxDeliveryDate
    ? 'Fechas solicitadas para la entrega'
    : 'Fechas solicitadas para la recolección';

  const emptyUserInformation =
    !deliveryInfo?.user?.maxDeliveryDate &&
    !collectionInfo?.user?.minCollectionDate &&
    !initialEstimatedDatesData?.collectionDatesText &&
    !validateEstimatedDeliveryDate &&
    !collectionInfo?.collectionComment &&
    !deliveryInfo?.deliveryComment;

  if (emptyUserInformation)
    return (
      <div className="userInformationDates">
        <div className="userInformationEmpty">
          <div className="userInformationEmptyIconContainer">
            <BordOneToneIcon variant="user" standardSize={32} />
          </div>
          <div className="userInformationEmptyDescription">
            En este espacio puedes consultar las fechas solicitadas por el usuario en nuevos servicios
          </div>
        </div>
      </div>
    );

  return (
    <div className="userInformationDates">
      {collectionInfo?.user?.minCollectionDate && (
        <div className="iconContainer w-48">
          <InfoDisplayItem
            oneToneIconProps={{
              variant: 'user',
              standardSize: 12
            }}
            text="Fecha de salida del empleado"
            value={transformMinCollectionDate ?? ''}
          />
        </div>
      )}
      {deliveryInfo?.user?.maxDeliveryDate && (
        <div className="iconContainer w-48">
          <InfoDisplayItem
            oneToneIconProps={{
              variant: 'user',
              standardSize: 12
            }}
            text="Fecha de ingreso del empleado"
            value={transforMaxDeliveryDate ?? ''}
          />
        </div>
      )}
      {initialEstimatedDatesData?.collectionDatesText && (
        <div className="iconContainer w-48">
          <InfoDisplayItem
            oneToneIconProps={{
              variant: 'calendar',
              standardSize: 12
            }}
            text={renderCollectionDateText}
            value={initialEstimatedDatesData?.collectionDatesText}
            dateCustomClassName="text-nudos-text-color"
          />
        </div>
      )}
      {validateEstimatedDeliveryDate && (
        <div className="iconContainer w-48">
          <InfoDisplayItem
            oneToneIconProps={{
              variant: 'calendar',
              standardSize: 12
            }}
            text="Fechas estimadas de entrega"
            value={initialEstimatedDatesData?.estimatedDeliveryText ?? ''}
            dateCustomClassName="text-nudos-text-color"
          />
        </div>
      )}
    </div>
  );
};

export default InitialEstimatedDates;
